import { Grid, makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import RoundedButton from '../../../components_v1/Actions/RoundedButton';
import InputSelect from '../../../components_v1/Forms/InputSelect';
import SimpleModal from '../../../components_v1/Structure/Modals/SimpleModal';
import { isFormValid, onGetCatalogs, onSetErrorsToForm } from '../../../shared/utility';
import DisplayText from '../../../components_v1/Texts/DisplayText';
import { request_businesses } from './requests';

const useStyles = makeStyles(theme => ({
    form:{
        paddingTop:32,
        paddingBottom:32
    }
}))

const BusinessFilterModal = (props) => {

    const classes = useStyles()
    const { open, onClose, onRequestUsers, history, onAddFilter } = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [file, setFile] = useState(null)
    const [businesses, setBusinesses] = useState([])
    const [services, setServices] = useState([])
    const [supervisors, setSupervisors] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (!open) {
            setForm(JSON.parse(JSON.stringify(formData)))
            setError(''); setLoading(false); setBusinesses([]); setInputValue('')
        }
    }, [open])

    const onChange = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        console.log('Hay cambio')
        if(id === 'business_id'){
            const new_value = data.value
            const elementFound = data.options.find(el => el.value === new_value)
            if(elementFound){setInputValue(elementFound.label)}else{setInputValue('')}
        }
        setForm(temp)
    }


    const onCloseInput = (data) => {
        console.log('on menu closed')
        const _value = data.value
        if(data.options.length === 0){
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data, value:null, isValid:false, isVisited:true }
            setInputValue('')
            setForm(temp)
        }
    }

    const onSearchBusiness = async(e) => {
        if(!e || e.target.value === 0) return
        setInputValue(e.target.value)
        try {
            const _businesses = await request_businesses(e.target.value)
            const _business_catalog = onGetCatalogs(_businesses, 'business_id', 'business')
            setBusinesses(_business_catalog)
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmit = async () => {
        const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            return
        }
        const data2send = businesses.find(el => el.value === form.business_id.value)
        if(!data2send) return
        onAddFilter(data2send, 'business')
        onClose()

    }

    // Update catalogs in real time 

    let business_form = {...form.business_id}
    business_form.options = [...businesses]

    return ( 
        <SimpleModal open={open} onClose={onClose} maxWidth='sm' padding='small'>
            <div>
                <div className={classes.form}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <DisplayText variant='subtitle1'>Seleccione un negocio</DisplayText>
                            <InputSelect data={business_form} onChange={onChange} onInputChange={onSearchBusiness} inputValue={inputValue} onClose={onCloseInput}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify='flex-end'>
                                <Grid item><RoundedButton onClick={onSubmit} >Seleccionar</RoundedButton></Grid>
                            </Grid>
                        </Grid>
                    
                    </Grid>
                </div>
            </div>
        </SimpleModal>
     );
}
 
export default BusinessFilterModal;

const formData = {
    business_id: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[],
        config: {
            id: 'business_id',
            type: 'select',
            fullWidth: true,
            label: '',
            placeholder:'Seleccione una opción',
            helper: 'Este campo es requerido'
        },
        rules: {type: 'select'}
    },
    
}